import { createRef } from "react"

const PassCodeInputField = ({ setValue, clearErrors }) => {

    const length = 6;
    const border = "border p-1";
    const refArr = new Array(length).fill(null).map(() => createRef());

    const handleChange = (e, fieldIndex) => {
        clearErrors();
        const { maxLength, value } = e.target
        if (value.length >= maxLength) { // check if max character length
            const nextRef = refArr[fieldIndex + 1] || refArr[length - 1]
            nextRef.current.focus();
        }
        if (fieldIndex === (length - 1)) {
            setValue("code", refArr.map(el => el.current.value).join(''))
        }
    }

    return (
        <div className="text-center">
            {refArr.map((item, i) => {
                return (
                    <input
                        key={i}
                        ref={item}
                        className={`${border} p-2 me-1 bg-light text-center`}
                        size="1"
                        type="text"
                        name={`digit-${i}`}
                        maxLength={1}
                        onChange={(e) => handleChange(e, i)}
                    />
                );
            })}
        </div>
    )
}

export default PassCodeInputField